import React, { useState } from 'react';
import { StyleSheet, Text, View} from 'react-native';
import { firebaseConfig } from './firebase';
import { initializeApp } from "firebase/app";
import LoginContext from './hooks/loginContext';
import { Router } from './Router';

function App() {

  const app = initializeApp(firebaseConfig);
  const [user, setUser] = useState(null);

  return (
    <LoginContext.Provider value={{user:user, login:()=>{}, setUser:setUser}}>
      <View style={{ height: '100%', width:'100%', alignItems:'center', backgroundColor:'#F3F4F6'}}>
        <View style={{height:'100%', width:'100vw', maxWidth:'500px'}}>
          <Router />
        </View>
      </View>
    </LoginContext.Provider>
  );
}


export default App;